import React from 'react'
import { getProjectStatus } from '../../utils/projectHelpers'

// حالة المشروع كشارة ملونة (جاري / متوقف / مكتمل / ملغي).
const ProjectStatusBadge = ({ status, lang = 'ar', size = 'md' }) => {
    const meta = getProjectStatus(status);
    const small = size === 'sm';
    return (
        <span
            data-testid="project-status"
            style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: small ? '2px 8px' : '4px 11px', borderRadius: 999, background: meta.bg, color: meta.color, fontSize: small ? 10.5 : 12, fontWeight: 800, whiteSpace: 'nowrap' }}
        >
            <span style={{ width: small ? 6 : 7, height: small ? 6 : 7, borderRadius: '50%', background: meta.dot }} />
            {lang === 'ar' ? meta.ar : meta.en}
        </span>
    );
};

export default ProjectStatusBadge
